<template>
  <div class="settings">
    <PageMenu :linksList="linksList" />
    <router-view />
  </div>
</template>

<script>
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'ShopsIndex',
  components: { PageMenu },
  data() {
    return {
      linksList: [
        {
          name: 'Shops',
          link: '/connect/shops',
        },
        {
          name: 'Shipping methods',
          link: '/connect/shipping-methods',
        },

      ],
    };
  },
};
</script>
